define('_views/Spotlight',[
	'text!_templates/spotlight.html',
	'../../_libs/Sortable.min.js',
	'_views/Fan-Spotlight'
],
function(
	spotlightTemplate,
	Sortable,
	FanView
) {
	return Backbone.View.extend({
		id: 'spotlight',

		template: _.template(spotlightTemplate),

		events: {
			'click [data-search-edit-toggle]'			: 'toggleEdit',
			'click [data-search-spotlight-open]'		: 'searchOpen',
			'click [data-search-spotlight-close]'		: 'searchClose',
			'click [data-search-spotlight-load-more]'	: 'loadMoreSearchFans',
			'click [data-remove-from-spotlight]'		: 'removeFanFromSpotlight',
			'click [data-sort-type]' 					: 'changeSortType',
			'keyup [data-search-spotlight] input'		: 'searchUpdate',
			'click [data-destination]' 					: 'navigate'
		},

		data: {
			searchActive: false
		},

		$els: {
			searchContainer: null
		},

		initialize: function() {
			// this.listenTo(this.model, "sync", this.render);
		},

		searchResults: [],

		lastSearchResultEnd: 0,

		render: function(show_search){
			this.modelsUpdate();

			this.$el.html(
				this.template({
					spotlight : JSON.parse(JSON.stringify(this.spotlight_models)),
					search : JSON.parse(JSON.stringify(this.search_models)),
					defaults  : this.model.toJSON()
				})
			);

			// Cache
			this.$els = {
				spotlightContainer: this.$el.find('[data-container-spotlight]'),
				emptySpotlightContainer: this.$el.find('[data-empty-spotlight-container]'),
				searchContainer: this.$el.find('[data-search-spotlight]'),
				searchHide: this.$el.find('[data-search-spotlight-hide]'),
				searchProfiles: this.$el.find('[data-search-spotlight-profiles]'),
				searchNoResults: this.$el.find('[data-spotlight-no-results]')
			}

			this.searchReset();
			this.showOrHideSearch();

			//_.each(this.spotlight_models.reverse(), _.bind(this.addSpotlightFan, this));
			
			if(this.model.get('fan_sort_type') == "recent") {
				this.renderRecentSpotlightFans();
			} else {
				this.renderManualSpotLightFans();
			}
			
			_.each(this.search_models, _.bind(this.addSearchFan, this));

			this.renderSearchFans(4);

			if(show_search) {
				this.toggleEdit();
			}
			
			// If there are no fans, then hide the header
			if(Backstage.Collection.fanOfCollection.length == 0) {
				$('[data-spotlight-header]', this.el).hide();

			// Less than 8, hide view all
			} else if(Backstage.Collection.fanOfCollection.length < 9) {
				$('[data-view-all]', this.el).hide();
			
			// Otherwise, show it
			} else {
				$('[data-view-all]', this.el).show();
			}

			// Check, and show, spotlight images if backstage is open
			this.checkAndShowFanImage();

			return this;
		},

		modelsUpdate: function () {
			this.spotlight_models = Backstage.Collection.fanOfCollection.where({ is_spotlight : true });
			this.search_models = Backstage.Collection.fanOfCollection.where({ is_spotlight : false });
			this.showOrHideSearch();
		},

		showOrHideSearch: function(){

			if(this.$els.searchContainer !== null) {

				if(this.search_models.length === 0) {
					this.$els.searchContainer.css('display', 'none');
				} else {
					this.$els.searchContainer.css('display', '');
				}

			}

		},

		/**
		 * Change between different sort types 
		 * This happens when the sort button is clicked
		 */
		changeSortType: function(e) {
			var fan_sort_type = $(e.currentTarget).data('sort-type');

			this.model.set('fan_sort_type', fan_sort_type);

			// Prevent the main view from rendering
			Backstage.View.Main.prevent_render = true;
			this.model.save({ reset : false });

			this.toggleEdit({}, true);
			this.searchClose();
			this.render(true);
		},

		/**
		 * Resorts the fan collection by recent
		 * loops through and renders the fans
		 */
		renderRecentSpotlightFans: function() {
			// Dump the content
			this.$els.spotlightContainer.empty();

			// Sort the model
			Backstage.Collection.fanOfCollection.comparator = "fan_date";

			Backstage.Collection.fanOfCollection.comparator = function(model) {
				return -model.get('fan_date');
			};

			Backstage.Collection.fanOfCollection.sort();

			var _this = this;

			Backstage.Collection.fanOfCollection.each(function(model, i) {
				if(i >= 8) {
					return;
				}

				// insert fan
				var fanView = new FanView({
					model: model
				});

				_this.$els.spotlightContainer.append(fanView.render().$el);
			});

			var collection_size = Backstage.Collection.fanOfCollection.length,
				diff = 0;

			// Find out how many are left on the row
			if(collection_size < 4) {
				diff = 4 % collection_size;
			} else if(collection_size < 8 && collection_size > 4) {
				diff = 8 % collection_size;
			}

			// Loop through the remainders and print blank spaces
			for(i = 0; i < diff; i++) {
				// insert blank
				this.$els.spotlightContainer.append(
					this.$els.emptySpotlightContainer.clone().css('display', '')
				);
			}
		},

		/**
		 * Resorts the fan collection by sort order
		 * loops through and renders the fans
		 */
		renderManualSpotLightFans: function(){

			var model, i;

			// Dump the content
			this.$els.spotlightContainer.empty();

			// Sort the model
			Backstage.Collection.fanOfCollection.comparator = "sort";
			Backstage.Collection.fanOfCollection.sort();

			// Get the updated spotlight models
			this.modelsUpdate();
			
			for(i = 0; i < 8; i++) {

				model = _.filter(this.spotlight_models, function(model){
							if(model.get('sort') === i) {
								return true;
							}
						})[0];

				if(model === undefined) {

					// insert blank
					this.$els.spotlightContainer.append(
						this.$els.emptySpotlightContainer.clone().css('display', '')
					);

				} else {

					// insert fan
					var fanView = new FanView({
						model: model
					});

					this.$els.spotlightContainer.append(fanView.render().$el);

				}

			}

		},

		/**
		 * To offload some of the load time, 
		 * only show the images when the backstage panel is open
		 */
		checkAndShowFanImage: function(force) {
			if(force === true || Backstage.View.Main.data.parent.Cargo.View.Backstage.enabled === true) {
				$(".spotlight-profile [data-fan-image]", this.el).each(function() {
					if($(this).data('img')) {
						$(this).css('background-image', 'url(' + $(this).data('img') + ')');
						$(this).removeAttr('data-img');
					}
				});
			}
		},

		removeFanFromSpotlight: function(e){

			e.preventDefault();

			var parent = $(e.currentTarget).closest('[data-fan-id]'),
				id = parseInt(parent.attr('data-fan-id'), 10);

			if(parent.length > 0 && isNaN(id) === false) {
				
				parent.replaceWith(this.$els.emptySpotlightContainer.clone().css('display', ''));

				Backstage.Collection.fanOfCollection.findWhere({ id: id }).set('is_spotlight', false);

				this.modelsUpdate();

				this.saveNewSortOrder();

			}
		},

		addSearchFan: function(model) {

			this.searchResults.push(model);

		},

		renderSearchFans: function(amount, offset){

			if(isNaN(offset)) {
				offset = 0;
			}

			if(isNaN(amount)) {
				amount = 4;
			}

			if(offset === 0) {
				this.$els.searchProfiles.html('');
			}

			var start = offset,
				end = Math.min(amount + offset, this.searchResults.length);

			if(start === end && start === 0) {
				this.$els.searchNoResults.css('display', '');
			} else {
				this.$els.searchNoResults.css('display', 'none');
			}

			for(var i = start; i < end; i++) {

				var fanView = new FanView({
					model: this.searchResults[i]
				});

				this.$els.searchProfiles.append(fanView.render().$el);

			};

			this.lastSearchResultEnd = end;
			this.checkLoadMoreButton();

		},

		loadMoreSearchFans: function(){

			this.renderSearchFans(4, this.lastSearchResultEnd);
			this.checkLoadMoreButton();

		},

		checkLoadMoreButton: function(){

			if(this.lastSearchResultEnd === this.searchResults.length) {
				$('[data-search-spotlight-load-more]').parent().css('display', 'none');
			} else {
				$('[data-search-spotlight-load-more]').parent().css('display', '');
			}

		},

		saveNewSortOrder: function(){

			$("[data-container-spotlight] > div", this.el).each(function(index, el){

				if(index >= 8) {

					if(el.hasAttribute('data-fan-id')) {
						var id = parseInt($(this).attr('data-fan-id'), 10);

						if(!isNaN(id)) {
							Backstage.Collection.fanOfCollection.findWhere({ id: id }).set('is_spotlight', false);
						}
					}

					if(el.parentNode !== null) {
						el.parentNode.removeChild(el);
					}

				}

			});

			var spotlight_list = new Array(8);

			$("[data-container-spotlight] [data-fan-id]", this.el).each(function(a,b) {

				var id = parseInt($(this).attr('data-fan-id'));

				spotlight_list[$(this).index()] = id;

				Backstage.Collection.fanOfCollection.findWhere({ id: id }).set('is_spotlight', true);
				
			});

			// update models
			this.modelsUpdate();

			// do a search on the changed collection
			this.$el.find('[data-search-spotlight] input').trigger('keyup');

			$.post(
				'/_api/v0/site/' + this.model.get('site_url') + '/spotlight', 
				{ order: spotlight_list }, 
				function() { 
					this.modelsUpdate();
				}
			);

			// Make sure all images are shown
			this.checkAndShowFanImage();
		},

		searchOpen: function () {
			if (this.data.searchActive) { return }

				var _this = this;

			var hiddenSlot;

			this.spotlightSort = Sortable.create(this.$els.spotlightContainer[0], {
				group: {
					name: 'spotlight',
					put: true
				},
				scroll: false,
				onSort: function(){

					if(hiddenSlot !== undefined && hiddenSlot.parentNode !== null && hiddenSlot.style.display === "none") {
						// move item to end of list to let saveNewSortOrder take 
						// care of it
						hiddenSlot.style.display = "";

						//if($(hiddenSlot).index() >= 8) {
							hiddenSlot.parentNode.appendChild(hiddenSlot);
						//}
					}

					hiddenSlot = undefined;

					_this.saveNewSortOrder();
				}
			});

			this.searchSort = Sortable.create(this.$els.searchProfiles[0], {
				group: {
					name: 'spotlight',
					put: false,
					pull: true
				},
				sort: false,
				onMove: function(e) {

					if(hiddenSlot !== undefined) {
						hiddenSlot.style.display = "";
					}

					//if(e.related.hasAttribute('data-empty-spotlight-container')) {
						
						hiddenSlot = e.related;
						hiddenSlot.style.display = "none";

					//}

				},
				onOriginalGroup: function(){
					if(hiddenSlot !== undefined) {
						hiddenSlot.style.display = "";
					}
				}
			});

			this.$els.searchHide.addClass('hidden-xs');
			this.$els.searchContainer.removeClass('hidden-xs');
			this.$els.spotlightContainer.addClass('spotlight-search-active');

			this.$els.spotlightContainer
				.find('[data-profile-spotlight]')
				.addClass('spotlight-move')
				.on('click', this.disableClick);

			this.$el.find('[data-search-spotlight] input').focus()

			this.data.searchActive = true;
		},

		searchClose: function () {
			if (! this.data.searchActive) { return }

			if (this.spotlightSort) { this.spotlightSort.destroy() }
			if (this.searchSort) { this.searchSort.destroy() }

			this.$els.searchHide.removeClass('hidden-xs');
			this.$els.searchContainer.addClass('hidden-xs');
			this.$els.spotlightContainer.removeClass('spotlight-search-active');

			this.$el.find('[data-search-spotlight] input')
				.val('')
				.trigger('keyup');

			this.$els.spotlightContainer
				.find('[data-profile-spotlight]')
				.removeClass('spotlight-move')
				.off('click', this.disableClick);

			this.data.searchActive = false;
		},

		toggleEdit: function(e, no_search) {
			// Toggle the editing classes
			this.$el.toggleClass('editing');

			// Remove the old type class
			this.$el.removeClass('recent').removeClass('manual');

			// Add the new type class
			this.$el.addClass( this.model.get('fan_sort_type') );

			// Toggle search if we need to
			if( !no_search && this.model.get('fan_sort_type') == "manual" ) {
				this.searchToggle();
			}
		},

		searchToggle: function () {
			if (this.data.searchActive) {
				this.searchClose()
			} else {
				this.searchOpen()
			}
		},

		searchUpdate: function (e) {
			var searchCollection =  [ ];
			var value = e.target.value;

			_.each(this.search_models, _.bind(function (self) {
				var score = this.searchScore(self.attributes.fan_site_name, value)

				if (score <= 0 && value.length > 0) {
					// Ignore
				} else {
					searchCollection.push({
						model: self, 
						score: score
					})
				}
			}, this))

			searchCollection = _.sortBy(searchCollection, function(self) {
				return -self.score;
			});

			this.searchReset();

			_.each(searchCollection, _.bind(function (self) {
				this.addSearchFan(self.model);
			}, this));

			this.renderSearchFans(4);
		},

		searchReset: function () {
			this.lastSearchResultEnd = 0;
			this.searchResults = [];
			this.$els.searchProfiles.html('');
			this.checkLoadMoreButton();
		},

		searchScore: function (term, word, fuzziness) {
			// Via https://github.com/joshaven/string_score

			// If the string is equal to the word, perfect match.
			if (term === word) { return 1; }

			//if it's not a perfect match and is empty return 0
			if (word === "") { return 0; }

			var runningScore = 0,
					charScore,
					finalScore,
					string = term,
					lString = string.toLowerCase(),
					strLength = string.length,
					lWord = word.toLowerCase(),
					wordLength = word.length,
					idxOf,
					startAt = 0,
					fuzzies = 1,
					fuzzyFactor,
					i;

			// Cache fuzzyFactor for speed increase
			if (fuzziness) { fuzzyFactor = 1 - fuzziness; }

			// Walk through word and add up scores.
			// Code duplication occurs to prevent checking fuzziness inside for loop
			if (fuzziness) {
				for (i = 0; i < wordLength; i+=1) {

					// Find next first case-insensitive match of a character.
					idxOf = lString.indexOf(lWord[i], startAt);

					if (idxOf === -1) {
						fuzzies += fuzzyFactor;
					} else {
						if (startAt === idxOf) {
							// Consecutive letter & start-of-string Bonus
							charScore = 0.7;
						} else {
							charScore = 0.1;

							// Acronym Bonus
							// Weighing Logic: Typing the first character of an acronym is as if you
							// preceded it with two perfect character matches.
							if (string[idxOf - 1] === ' ') { charScore += 0.8; }
						}

						// Same case bonus.
						if (string[idxOf] === word[i]) { charScore += 0.1; }

						// Update scores and startAt position for next round of indexOf
						runningScore += charScore;
						startAt = idxOf + 1;
					}
				}
			} else {
				for (i = 0; i < wordLength; i+=1) {
					idxOf = lString.indexOf(lWord[i], startAt);
					if (-1 === idxOf) { return 0; }

					if (startAt === idxOf) {
						charScore = 0.7;
					} else {
						charScore = 0.1;
						if (string[idxOf - 1] === ' ') { charScore += 0.8; }
					}
					if (string[idxOf] === word[i]) { charScore += 0.1; }
					runningScore += charScore;
					startAt = idxOf + 1;
				}
			}

			// Reduce penalty for longer strings.
			finalScore = 0.5 * (runningScore / strLength    + runningScore / wordLength) / fuzzies;

			if ((lWord[0] === lString[0]) && (finalScore < 0.85)) {
				finalScore += 0.15;
			}

			return finalScore;
		},

		disableClick: function (e) {
			e.preventDefault();
			return false;
		}
		
	});
});

